import React from "react";
import { Link, useHistory } from "react-router-dom";
import {
  Anchor,
  Icon,
  Type,
  useMediaQuery,
} from "@ebscois/react-component-library";
import {
  CheekyListItem,
  StyledButton,
  StyledBookmarkFlex,
  StyledPubTypeFlex,
  StyledTitleFlex,
} from "./BookmarkItemRow.styled";
import { useDispatch, useStore } from "../../store";
import { deleteBookmark } from "../../store/actions/bookmark";
import { logBookmarkedItemClicked } from "../../util/analytics";

export default function BookmarkItemRow({ bookmark, bookmarkIndex }) {
  const isMobile = useMediaQuery("max", "sm");
  const dispatch = useDispatch();
  const history = useHistory();
  const {
    bookmark: { isDeleting },
  } = useStore();

  const handleBookmarkDelete = async () => {
    await deleteBookmark(dispatch, bookmark?.metadata?.slug, bookmarkIndex);
    const { pathname, search, hash, state } = history.location;
    const rebuiltPath = `${pathname}${search}${hash}`;
    history.replace(rebuiltPath, {
      ...state,
      isFetchBookmarks: true,
    });
  };

  return (
    <CheekyListItem container>
      <StyledBookmarkFlex
        data-testid="bookmark-title"
        cell
        column={isMobile}
        width={85}
      >
        <StyledPubTypeFlex align={{ content: "center" }}>
          <Type
            element="span"
            display="block"
            fontSize={isMobile ? "sm" : "md"}
            color="gray700"
            textTransform="uppercase"
          >
            {bookmark?.metadata?.prettyPubtype}
          </Type>
        </StyledPubTypeFlex>
        <StyledTitleFlex>
          <Anchor
            data-testid="bookmark-link"
            fontSize="md"
            href={bookmark?.metadata?.slug}
            linkComponent={Link}
            onClick={() =>
              logBookmarkedItemClicked({
                title: bookmark?.metadata?.title,
                record_an: bookmark?.an,
              })
            }
          >
            {bookmark?.metadata?.title}
          </Anchor>
        </StyledTitleFlex>
      </StyledBookmarkFlex>
      <StyledButton
        style={{ justifyContent: "flex-end" }}
        data-testid="bookmark-delete-button"
        kind="anchor"
        size="iconOnly"
        padded={false}
        variant="light"
        onClick={() => !isDeleting && handleBookmarkDelete()}
        disabled={isDeleting}
      >
        <Icon
          data-testid="bookmark-delete-icon"
          icon={{
            size: "lg",
            glyph: "delete",
            color: !isDeleting && "gray600",
          }}
        />
      </StyledButton>
    </CheekyListItem>
  );
}
